import { __rest } from "tslib";
import React, { useContext, useEffect, useRef, } from 'react';
import styled from 'styled-components';
import { FoundationContextProvider } from '@clds/design-system-foundations';
import { TabChildrenWrapper, TabContent } from './TabContent';
import { TabsContext } from './TabsContext';
const ENTER_KEY_CODE = 13;
const SPACE_KEY_CODE = 32;
export const Tab = styled((_a) => {
    var { ariaControls, children, disabled, icon, id, onClick } = _a, rest = __rest(_a, ["ariaControls", "children", "disabled", "icon", "id", "onClick"]);
    const tabNodeRef = useRef(null);
    const { activeTabId, setActiveTabRef, variant, orientation, layout } = useContext(TabsContext);
    const isActive = id === activeTabId;
    const tabIndex = disabled ? -1 : 0;
    useEffect(() => {
        if (isActive) {
            setActiveTabRef === null || setActiveTabRef === void 0 ? void 0 : setActiveTabRef(tabNodeRef);
        }
    }, [isActive, setActiveTabRef]);
    const handleClick = () => {
        onClick();
    };
    const handleKeyDown = (event) => {
        if ([ENTER_KEY_CODE, SPACE_KEY_CODE].includes(event.which)) {
            onClick();
        }
    };
    return (React.createElement(TabContent, Object.assign({ size: "sm", active: isActive, "aria-controls": ariaControls, "aria-selected": isActive, disabled: disabled, orientation: orientation, layout: layout, variant: variant, onClick: handleClick, onKeyDown: handleKeyDown, ref: tabNodeRef, role: "tab", tabIndex: tabIndex }, rest),
        React.createElement(FoundationContextProvider, { size: "md" }, icon),
        children && React.createElement(TabChildrenWrapper, null, children)));
}) ``;
//# sourceMappingURL=Tab.js.map